import {
    Box,
    Step,
    StepIndicator, StepNumber, Stepper as ChakraStepper, StepSeparator, StepStatus, StepTitle,
    Text,
    useBreakpointValue,
    useToken,
} from '@chakra-ui/react';

export function Stepper({
    activeStep,
    steps,
}: {
    activeStep: number;
    steps: {
        title: string;
        description?: string;
    }[];
}) {
    const INCOMPLETE_COLOR = useToken('colors', 'muted.200');
    const LINE_COLOR = useToken('colors', 'muted.200');
    const STEP_NUMBER_FONT_SIZE = useToken('fontSizes', 'xs');

    // We have a base value, so this will always return a value
    const orientation = useBreakpointValue(['vertical', 'horizontal'], {
        // Stop it from flashing the mobile version on first render
        ssr: false,
    }) as 'vertical' | 'horizontal';

    return (
        <ChakraStepper index={activeStep} colorScheme="secondary" size="sm" orientation={orientation}>
            {steps.map((step) => (
                <Step key={step.title}>
                    <StepIndicator
                        style={{ fontWeight: 'bold', border: 'none' }}
                        sx={{
                            '[data-status=complete] &': {
                                background: INCOMPLETE_COLOR,
                            },
                            '[data-status=active] &': {
                                background: 'secondary.500',
                            },
                            '[data-status=incomplete] &': {
                                backgroundColor: INCOMPLETE_COLOR,
                            },
                        }}
                    >
                        <StepStatus
                            complete={<StepNumber style={{ color: 'white', fontSize: STEP_NUMBER_FONT_SIZE }} />}
                            incomplete={(
                                <StepNumber
                                    style={{
                                        color: 'white',
                                        fontSize: STEP_NUMBER_FONT_SIZE,
                                    }}
                                />
                            )}
                            active={(
                                <StepNumber style={{ color: 'white', fontSize: STEP_NUMBER_FONT_SIZE }} />
                            )}
                        />
                    </StepIndicator>

                    <Box flexShrink="0">
                        <StepTitle>
                            <Text
                                sx={{
                                    '[data-status=complete] &': {
                                        fontWeight: 'initial',
                                    },
                                    '[data-status=incomplete] &': {
                                        color: INCOMPLETE_COLOR,
                                        fontWeight: 'initial',
                                    },
                                }}
                            >
                                {step.title}
                            </Text>
                        </StepTitle>
                    </Box>

                    <StepSeparator style={{ height: 0.5, backgroundColor: LINE_COLOR }} />
                </Step>
            ))}
        </ChakraStepper>
    );
}
